var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMilesDonate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28657",
    "data-name": "Group 28657",
    transform: "translate(-1925 -3114)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37445",
    "data-name": "Path 37445",
    d: "M628.079,472.079a28,28,0,1,0,28,28A28,28,0,0,0,628.079,472.079Z",
    transform: "translate(1324.921 2641.921)",
    fill: "#fc3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-heart",
    "data-name": "Icon feather-heart",
    d: "M24.472,6.348a6.315,6.315,0,0,0-8.933,0L14.323,7.565,13.106,6.348a6.316,6.316,0,1,0-8.933,8.933L5.39,16.5l8.933,8.933L23.255,16.5l1.217-1.217a6.315,6.315,0,0,0,0-8.933Z",
    transform: "translate(1939.177 3128.003)",
    fill: "none",
    stroke: "#1c1c1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMilesDonate);
export default __webpack_public_path__ + "static/media/miles-donate.ad8b7214f970c7d8197121faa09eca50.svg";
export { ForwardRef as ReactComponent };